import { BookCardType } from '@models/myReading/BookCardType'
import { Expose, Type } from 'class-transformer'

export class CampaignResponse {
  @Expose() page: number

  @Expose({ name: 'data' })
  @Type(() => BookCardType)
  campains: BookCardType[]

  @Expose()
  total: number
}
